/**
 * @generated SignedSource<<5ad2da732acab45201d51a7e4e837442>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type teamInlineFragment$data = {
  readonly id: string;
  readonly accountId: string;
  readonly account: {
    readonly " $fragmentSpreads": FragmentRefs<"accountBaseInlineFragment" | "accountDetailsFragment" | "accountAddressFragment">;
  };
  readonly members: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"teamMemberInlineFragment">;
  }> | null;
  readonly " $fragmentType": "teamInlineFragment";
};
export type teamInlineFragment$key = {
  readonly " $data"?: teamInlineFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"teamInlineFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "teamInlineFragment"
};

(node as any).hash = "4460fb824f32cd6d851411588f863f48";

export default node;
